import { ScheduleTimeGridItem } from './schedule-time-grid-item.components';
import { SingleColLoading } from './time-grid-loading.component';
import { EmptyCol } from './schedule-time-grid-item.components';

import { ScheduleType } from '@/app/(main)/(pages)/busca/[slug]/_types/search-partner-data.type';
import { TimeGrid } from '@/app/(main)/(pages)/busca/[slug]/_consts';
import { useInfiniteScroll } from '@/hooks/use-infinite-scroll.hook';
import { useGridCol } from '@/app/(main)/(pages)/busca/[slug]/_hooks/use-grid-col.hook';

interface ScheduleTimeProps {
  scheduleType: ScheduleType;
  timeGrid: TimeGrid[];
  fetchNewSlots: () => void;
  showAll?: boolean;
  hasEnded?: boolean;
}

export function TimeGridSlots({ scheduleType, timeGrid, fetchNewSlots, showAll, hasEnded }: ScheduleTimeProps) {
  const { infiniteScrollRef } = useInfiniteScroll(fetchNewSlots);

  const cols = useGridCol({ scheduleType });

  const maxSize = showAll ? timeGrid.reduce((acc, curr) => Math.max(acc, curr.times.length), 0) : undefined;

  const remainingCols = hasEnded ? (cols - (timeGrid.length % cols)) % cols : 0;

  return (
    <>
      {timeGrid.map((day) => (
        <ScheduleTimeGridItem key={day.day} day={day} scheduleType={scheduleType} />
      ))}
      {remainingCols > 0
        && Array.from({ length: remainingCols }).map((_, index) => (
          <EmptyCol scheduleType={scheduleType} key={`key-empty-col-${index}`} />
        ))}
      {timeGrid.length > 0 && !hasEnded && (
        <div className="w-full h-full flex justify-between ml-2 min-w-0 shrink-0 grow-0 align-top gap-y-1">
          {Array.from({ length: cols }).map((_, index) => (
            <SingleColLoading
              key={`key-loading-col-${index}`}
              scheduleType={scheduleType}
              size={maxSize}
              ref={infiniteScrollRef}
            />
          ))}
        </div>
      )}
    </>
  );
}
